import { IconBaseType } from "@/v2-components/core/icon/type";
import { cn } from "@/libs/utils";

export default function ChevronLeftIcon({ className }: IconBaseType) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("w-6 h-6", className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.05155 13.0652L13.9439 18L15 16.9348L10.1076 12L15 7.06523L13.9439 6L9.05155 10.9348L7.99547 12L9.05155 13.0652Z"
        fill="currentColor"
      />
    </svg>
  );
}
